import React, { useState, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import Modal from "components/ui/Modal";
import Button from "./Button";
import { combineObject } from "utils/object";
import Text from "components/ui/Text";

export const Confirm = (message, option) => {
  option = combineObject(
    {
      title: "",
      button: {
        left: {
          name: "Cancel",
          color: "red",
        },
        right: {
          name: "Okay",
          color: "green",
        },
      },
      callback: undefined,
    },
    option || {},
  );
  const eventHandler = {
    close: () => {
      Modal();
      if (option.callback) option.callback(false);
    },
    submit: () => {
      Modal();
      if (option.callback) option.callback(true);
    },
  };
  Modal(
    <Wrapper>
      <div className="middle">
        <Text
          display="block"
          fontSize="17px"
          fontWeight="700"
          lineHeight="20px"
        >
          {option.title}
        </Text>
        <Text
          display="block"
          color="gray50"
          fontSize="15px"
          fontWeight="500"
          lineHeight="23px"
          css={css`
            margin-top: ${message ? "16px" : 0};
            white-space: pre;
          `}
        >
          {message}
        </Text>
      </div>
      <div className="bottom">
        <Button
          outline
          color={option.button.left.color}
          onClick={eventHandler.close}
        >
          <Text
            color={option.button.left.color}
            fontSize="15px"
            fontWeight="700"
            lineHeight="15px"
          >
            {option.button.left.name}
          </Text>
        </Button>
        <Button
          outline
          color={option.button.right.color}
          onClick={eventHandler.submit}
        >
          <Text
            color={option.button.right.color}
            fontSize="15px"
            fontWeight="700"
            lineHeight="15px"
          >
            {option.button.right.name}
          </Text>
        </Button>
      </div>
    </Wrapper>,
  );
};

const Wrapper = styled.div`
  & {
    max-width: 320px;
  }
  .middle {
    padding: 25px !important;
  }
  .middle span {
    text-align: center;
  }
  .bottom {
    padding: 0 !important;
  }
  .bottom button {
    width: 100% !important;
    border-radius: 0;
  }
  .bottom button + button {
    border-left: 1px solid var(--border) !important;
  }
`;

export default Confirm;
